import styles from './index.scss'
import classnames from 'classnames'


interface IDpFlex {
  prefix?: any
  children?: any
  extra?: any
  type?: string
  style?: React.CSSProperties
}

const Item = (props: IDpFlex) => {
  return (
  <div className={styles["dp-flex-item"]} style={props?.style}>
    {props?.children}
  </div>
  )
}

const DpFlex = (props: IDpFlex) => {
  return (
    <div
      className={classnames([ styles["dp-flex"], {[styles[`dp-flex-${props?.type}`]]: true}])}
      style={props?.style}
    >
      {props?.children}
    </div>
  )
}

DpFlex.Item = Item as any
export default DpFlex
